<button [type]="type" class="btn" (click)="onClick()">
  {{ text }}
</button>